import { COLORS } from '../../../common/utils/icon/constants';
import { getIcon } from '../../../common/utils/icon/icon';
const getStyles = notNeutral => `
  height: auto;
  ${notNeutral && 'margin-top: 5%'};
  width: ${notNeutral ? '61%' : '100%'};
`;
const configuration = {
  colors: [COLORS.blue, COLORS.white],
  getStyles,
  id: 'shield'
};
export default type => getIcon({
  ...configuration,
  type
});
//# sourceMappingURL=icon.js.map